import { Turbo } from '@hotwired/turbo-rails'

// Ensure that the responseHTML is loaded before the fetchRequest is declared finished
// @see https://github.com/hotwired/turbo/pull/1377
const originalReceive = Turbo.FetchRequest.prototype.receive
Turbo.FetchRequest.prototype.receive = async function(response) {
  let fetchResponse = await originalReceive.call(this, response)
  await fetchResponse.responseHTML
  return fetchResponse
}

// Ensure that the correct Turbo-Frame is passed when using target=_top
// @see https://github.com/hotwired/turbo/issues/1349
const originalPrepareRequest = Turbo.session.linkPrefetchObserver.prepareRequest
Turbo.session.linkPrefetchObserver.prepareRequest = function(request) {
  originalPrepareRequest.call(this, request)
  if (request.headers['Turbo-Frame'] === '_self') {
    request.headers['Turbo-Frame'] = request.target.closest('turbo-frame')?.id
  }
}

// Apply aria-busy on submitters to indicate that the form is being submitted.
// This lets us target styling to the submitter.
const { beforeSubmit, afterSubmit } = Turbo.config.forms.submitter
Turbo.config.forms.submitter = {
  beforeSubmit: submitter => {
    submitter.setAttribute('aria-busy', 'true')
    beforeSubmit(submitter)
  },
  afterSubmit: submitter => {
    submitter.removeAttribute('aria-busy')
    afterSubmit(submitter)
  }
}